import React from 'react';

export function CitationPicker({ parameters, onChange }) {
  return (<div></div>);
}